import styled from 'styled-components';

import { Color, Spacing, Media } from '../../theme';

export const Container = styled.div`
  background-color: ${Color.darkGrey};
`;

export const PromotionsLogoContainer = styled.div``;

export const EULogo = styled.img`
  height: 76px; 
  ${Media.desktop`
    margin-top: 15px;
    margin-bottom: 15px;
  `};
`;

export const EULogosContainer = styled.div`
  padding: 60px ${Spacing.DesktopWide};
  background-color: ${Color.white};
  border-top: 1px solid ${Color.mediumLightGrey};
  ${Media.desktopWide`
    padding: 60px;
  `};
  ${Media.desktop`
    padding: 60px ${Spacing.Desktop};
  `};
  ${Media.tablet`
    padding: 45px ${Spacing.Tablet};
  `};
`;

export const EULogosInnerContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  max-width: 1200px;
  margin: 0 auto;
  ${Media.desktop`
    flex-direction: column;
  `};
`;

export const TopContainer = styled.div`
  display: flex;
  justify-content: space-between;
  padding: 80px ${Spacing.DesktopWide};
  max-width: 1200px;
  margin: 0 auto;
  ${Media.desktop`
    padding: 75px ${Spacing.Desktop};
  `}
  ${Media.tablet`
    flex-direction: column;
    padding: 60px ${Spacing.Tablet};
  `}
`;

export const BottomContainer = styled.div`
  border-top: 1px solid ${Color.veryDarkGrey};
`;

export const BottomInnerContainer = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  padding: 40px ${Spacing.DesktopWide} 60px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  ${Media.desktop`
    padding: 40px ${Spacing.Desktop} 60px;
  `}
  ${Media.tablet`
    flex-direction: column;
    align-items: flex-start;
    padding: 30px ${Spacing.Tablet} 40px;
  `}
`;

export const MenuContainer = styled.div`
  display: flex;
`;

export const MenuPositionItem = styled.div`
  font-size: 22px;
  letter-spacing: 0.18px;
  line-height: 24px;
  word-break: break-word;
  & + & {
    margin-top: 20px;
  }
  a {
    text-decoration: none;
    color: ${Color.white};
  }
  ${Media.tablet`
    font-size: 20px;
    letter-spacing: 0.16px;
  `}
`;

export const MenuColumn = styled.div``;

export const MenuColumnsContainer = styled.div`
  display: flex;
  &:nth-of-type(2) {
    margin-left: 100px;
    ${MenuPositionItem} {
      font-size: 14px;
      letter-spacing: 0;
      a {
        color: ${Color.silver};
      }
      & + ${MenuPositionItem} {
        margin-top: 5px;
      }
    }
    ${MenuColumn}:nth-of-type(2) {
      margin-left: 80px;
      ${Media.tablet`
        margin-left: 0;
        margin-top: 5px;
      `}
    }
    ${Media.tablet`
      flex-direction: column;
    `}
    ${Media.mobile`
      margin-left: 60px;
    `}
  }
`;

export const SocialContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  ${Media.tablet`
    align-items: flex-start;
    margin-top: 60px;
  `}
`;

export const CompanyLogoContainer = styled.div`
  margin-bottom: 90px;
  ${Media.tablet`
    align-items: flex-start;
    margin-bottom: 40px;
  `}
`;

export const SocialIconContainer = styled.a`
  height: 54px;
  width: 54px;
  border: 1px solid ${Color.mediumDarkGrey};
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
  cursor: pointer;
  transition: background-color 0.3s;
  & + & {
    margin-left: 10px;
  }
  &:hover {
    background-color: ${Color.mediumDarkGrey};
  }
`;

export const SocialIcon = styled.img`
  height: 18px;
`;

export const CopyrightText = styled.div`
  color: ${Color.silver};
  font-size: 14px;
  letter-spacing: 0;
  line-height: 18px;
  ${Media.tablet`
    padding-top: 5px;
  `}
`;

export const SocialIconsContainer = styled.div`
  display: flex;
  align-items: center;
`;

export const CopyrightLink = styled.a`
  color: ${Color.silver};
  text-decoration: none;
  &:hover {
    opacity: 0.6;
  }
`;

export const ExternalLink = styled.a``;
